const scaleScore = (val: number, min: number, top: number, { topPercentile = 75 } = {}) => {
  if (val <= min) {
    return 0;
  }
  const score = Math.max(Math.round(topPercentile * ((val - min) / (top - min))), 0);
  if (score > topPercentile) {
    const remainingPercentile = 100 - topPercentile;
    const excessOverPercentile = score - topPercentile;
    return Math.round(
      topPercentile +
        remainingPercentile * (excessOverPercentile / (remainingPercentile + excessOverPercentile)),
    );
  }
  return score;
};

export default scaleScore;
